import { useEffect } from 'react';
import { prop } from 'ramda';
import { useLuckyPopup } from '../../popups/IFeelLuckyPopup';
import { useAppSelector, useGameConfigurationSelector } from 'js/store/hooks';
import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from './constants';

export const IFeelLucky = ({ config }) => {
    let merged;
    let currentFeeds;
    let allGames;
    const gamesFromAllCategories = [];
    const minGamesToDisplayWidget = 20;
    const iFeelLuckyConf = config;
    const oldGamesFeeds = useAppSelector(prop('oldGamesFeeds'));
    const games = useGameConfigurationSelector(prop('games'));

    if (games) {
        allGames = Object.values(games);
    }

    const configuredGameFeeds = iFeelLuckyConf && iFeelLuckyConf.gameFeed.split(',').map(item => item.trim());

    if (configuredGameFeeds) {
        currentFeeds = oldGamesFeeds?.filter(feed => configuredGameFeeds.includes(feed.name));
    }

    currentFeeds && currentFeeds.forEach((feed) => {
        feed.categories.forEach((category) => {
            gamesFromAllCategories.push(category.gameCodes);
        });
    });

    if (gamesFromAllCategories.length > 0) {
        merged = [].concat(...gamesFromAllCategories);
    }

    const filterGames = merged && allGames.filter(game => merged.includes(game.gameCode));

    const uniqueGames = filterGames &&
        filterGames.filter((obj, pos, arr) => arr.map(mapObj => mapObj.gameCode).indexOf(obj.gameCode) === pos);

    const showLuckyPopup = useLuckyPopup(uniqueGames);

    const isShow = uniqueGames && uniqueGames.length > minGamesToDisplayWidget;

    useEffect(() => {
        if (isShow) {
            window.Playtech.API.iFeelLuckyOpen = () => showLuckyPopup();
        }
    }, [isShow, showLuckyPopup]);

    return null;

    /**
     * For display Launcher please use:
     *
     * return !isShow ? null : isShow && (
     *         <>
     *             { <Launcher
     *                 widgetPosition={iFeelLuckyConf && iFeelLuckyConf.widgetPosition}
     *                 widgetIcon={iFeelLuckyConf && iFeelLuckyConf.widgetIcon}
     *                 isDisabled={false}
     *                 onClick={showLuckyPopup}
     *             /> }
     *         </>
     *     );
     *
     */
};

tagTypeService.registerTagType({ [TAG_TYPE]: IFeelLucky });
